module.exports = __webpack_public_path__ + "static/img/szbl.9f98359.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/szbl.png
// module id = G3uY
// module chunks = 1